// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"b1866828","453":"c30bcd2e"}[chunkId] + ".chunk.js";
};